import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=32b586fc&scoped=true"
import script from "./BrandsList.vue?vue&type=script&lang=js"
export * from "./BrandsList.vue?vue&type=script&lang=js"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=32b586fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b586fc",
  null
  
)

export default component.exports